export enum ChipFace {
  PRIMARY = 'primary',
  DEFAULT = 'default',
  DANGER = 'danger',
  WARNING = 'warning'
}
